<template>
  <div class="row">
    <div class="col-md-4">
      <label> {{ name }} </label>
    </div>
    <div class="col-md-8">
      <input class="form-control-sm"
             type="number"
             :min="min"
             :max="max"
             :id="id"
             :disabled="disabled"
             :value="value"
             :data-help="help"
             @input="change(attId, attInfoId, ownerId, listType, $event.target.value, min,max)"
      />
    </div>
  </div>
</template>

<script>
import { useStore } from "vuex";
  export default {
    name: "AttributeNumber",
    components: {},
    props: {
      id: Number,
      value: Number,
      name: String,
      attId: Number,
      disabled: Boolean,
      attInfoId:Number,
      ownerId: Number,
      listType: String,
      min: Number, 
      max: Number,
      help: String,
    },
    setup() {
      const store = useStore();
      const change = function (id, attInfoId, ownerId, listType, value, min, max) {
        // console.log('index is ', id);
        // console.log('value is ', value);
        if (value >= min && value <= max) {
          store.dispatch('user/upsertAttribute', {
            attribute_value: value,
            attribute_info_id: attInfoId,
            owner_id: ownerId,
            list_type: listType,
          });
        } else {
          alert (`The value for this attribute must be greater than ${min} and lower than ${max}`);
        }
      }
      return{
        change,
      }
    },
  };
</script>

<style scoped>
  input {
    width:100%;
  }
</style>